<div *ngIf="isLoading">Loading Portfolio List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="portfolio" [(ngModel)]="model.portfolio" [required]="required">
  <option [ngValue]="null">No Portfolio</option>
  <option *ngFor="let singlePortfolio of portfolios" [ngValue]="singlePortfolio">{{ singlePortfolio.name }}</option>
</select>
